import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { Params } from "@angular/router";
import { Observable } from "rxjs";
import { AnyObject, SelectProperty } from "../../../types/app.type";
import { FilterType } from "../search-bar.component";
import { SearchInputOption, SearchInputType } from "../search-input/search-input.component";

export interface SearchFilterOption<T = AnyObject> {
  id?: string;
  value: string;
  auxValue?: string;
  label: string;
  disabled?: boolean;
  hidden?: boolean;
  minLength?: number;
  inputDisabled?: boolean;
  inputType?: SearchInputType;
  options?: SearchInputOption[];
  asyncOptions?: (payload?: Payload<T>) => Observable<SearchInputOption[]>;
  search?: AsyncSearchFilter;
  condition?: ConditionFilter;
  filterByProperty?: SelectProperty<T> | SelectProperty<T>[];
  filterByFunction?: (value: FilterType) => AnyObject | AnyObject[];
}
interface Payload<T> {
  body?: T;
  queryParams?: Params;
}

interface AsyncSearchFilter<T = AnyObject> {
  callback: (payload?: Payload<T>) => Observable<SearchInputOption[]>;
  loading?: boolean;
}

export type ConditionFilter =
  | "$not"
  | "$eq"
  | "$ne"
  | "$gt"
  | "$gte"
  | "$lt"
  | "$lte"
  | "$starts"
  | "$ends"
  | "$cont"
  | "$ncont"
  | "$in"
  | "$nin"
  | "$any"
  | "$between";

@Component({
  selector: "app-search-filter",
  templateUrl: "./search-filter.component.html",
  styleUrls: ["./search-filter.component.scss"],
})
export class SearchFilterComponent implements AfterContentChecked {
  @Input() disabled: boolean;
  @Input() selectedOption: SearchFilterOption;
  @Input() options: SearchFilterOption[];
  @Output() changeEvent = new EventEmitter<SearchFilterOption>();
  constructor(private changeDetector: ChangeDetectorRef) {}

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  changeSelection(): void {
    this.changeEvent.emit(this.selectedOption);
  }
}
